import { render, staticRenderFns } from "./BrandItemAssociation.vue?vue&type=template&id=5859cbf4&"
import script from "./BrandItemAssociation.vue?vue&type=script&lang=js&"
export * from "./BrandItemAssociation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports